export const INITIAL_PAGE_INDEX = 0
export const SMALL_ITEMS_PER_PAGE = 12
export const BIG_ITEMS_PER_PAGE = 15
export const SMALL_LANDING_ITEMS_PER_PAGE = 8
export const BIG_LANDING_ITEMS_PER_PAGE = 10
export const SMALL_MORE_FROM_STORE = 4
export const BIG_MORE_FROM_STORE = 5

